export default "__VITE_ASSET__5e27f175__"